import React, { createContext, useState, useEffect, useContext } from 'react';
import { BusinessContext } from './BusinessContext';  // Import BusinessContext

export const ReviewsContext = createContext();

const API_URL = process.env.REACT_APP_API_URL;

export const ReviewsProvider = ({ children }) => {
  const [reviewsData, setReviewsData] = useState([]);
  const [timeframe, setTimeframe] = useState(() => {
    return localStorage.getItem("timeframe") || "30";
  });
  const [view, setView] = useState(() => {
    return localStorage.getItem("view") || "Sales";
  });
  // Sort options: 'total', 'positive', 'negative'
  const [sortOption, setSortOption] = useState(() => {
    const savedSortOption = localStorage.getItem("sortOption");
    // Only use saved value if it's valid, otherwise default to "total"
    return (savedSortOption === "total" || savedSortOption === "positive" || savedSortOption === "negative") 
      ? savedSortOption 
      : "total";
  });

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedAttribute, setSelectedAttribute] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  
  const { selectedBusiness } = useContext(BusinessContext);
  const [showColoredText, setShowColoredText] = useState(false);
  
  useEffect(() => {
    // Save the timeframe to localStorage whenever it changes
    localStorage.setItem("timeframe", timeframe);
    localStorage.setItem("view", view);
    localStorage.setItem("sortOption", sortOption);
    const fetchReviews = async () => {
      try {
        let url = `${API_URL}/reviews/`;  // Base API endpoint

        // Only add start_date if timeframe is not "all"
        if (timeframe !== "all") {
          const parsedTimeframe = parseInt(timeframe, 10);
          if (!isNaN(parsedTimeframe)) {
            const startDate = new Date(Date.now() - parsedTimeframe * 24 * 60 * 60 * 1000).toISOString();
            url += `?start_date=${encodeURIComponent(startDate)}`;
          }
        }

        const response = await fetch(url, {
          method: 'GET',
          credentials: 'include',
        });
        if (response.ok) {
          const data = await response.json();
          // Sort reviews by date in descending order (newest first)
          const sortedReviews = (data.reviews || []).sort((a, b) => {
            return new Date(b.estimated_datetime) - new Date(a.estimated_datetime);
          });
          setReviewsData(sortedReviews);
        }
      } catch (error) {
        console.error('Error fetching reviews:', error);
      }
    };

    fetchReviews();
  }, [timeframe, selectedBusiness, view, sortOption]);

  return (
    <ReviewsContext.Provider value={{
      reviewsData, setReviewsData,
      timeframe, setTimeframe, view, setView,
      selectedCategory, setSelectedCategory,
      selectedSubject, setSelectedSubject,
      selectedAttribute, setSelectedAttribute,
      selectedDate, setSelectedDate,
      showColoredText, setShowColoredText,
      sortOption, setSortOption,
    }}>
      {children}
    </ReviewsContext.Provider>
  );

}
